import { LocalizationModel } from '@shared/core';
import { IBaseResponseModel } from './base.model';
import { IFineFixationModel } from './fine-fixation.model';
import { IParkingModel } from './parking.model';

export interface IFineSessionModel {
  uuid: string;
  carno: string;
  startTime: string;
  endTime: string;
  zone: string;
  status: number;
  isSend: boolean;
}
export interface IFineSessionDetailsModel {
  zone: { uuid: string };
  complexId: string;
  parkings: IParkingModel[];
  parkingFixationCount: string;
  fixations: IFineFixationModel[];
  combinedImageBase64: string;
  rec: IFineSessionModel;
  tariff: {
    uuid: string;
    description: LocalizationModel;
    name: LocalizationModel;
  };
}

export interface IFineSessionResponseModel extends IBaseResponseModel {
  rec: IFineSessionModel[];
}

export interface IFineSessionFilterModel {
  page?: number;
  pageSize?: number;
  zones?: string;
  query?: string;
  startDate?: number;
  endDate?: number;
}

export enum SessionStatus {
  SessionStatusValid = 100, // Session is legal    SessionStatusUncertain       = 300 // Session requires additional checks
  SessionStatusInvalid = 301, // Session is illegal (after additional checks)    SessionStatusInvalidSequence = 400 // Incorrect sequence of fixations
  MiniSessionStatusValid = 200, // Mini-session is legal
  MiniSessionStatusFreePeriod = 201, // Mini-session is free (e.g., zero tariff cost)    MiniSessionStatusPaid       = 200 // Mini-session is covered by payment
  MiniSessionStatusUncertain = 300, // Mini-session requires additional checks (initial status)
  BenefitCodeMonthlyAbonement = 212,
  Assigned = 500,
  SendErap = 501,
  Legal = 502,
  Confirm = 503,
}

export const ISessionStatusLabel: Record<SessionStatus, string> = {
  [SessionStatus.SessionStatusInvalid]: 'ADMIN_SESSION_STATUS_NO_PAYMENT',
  [SessionStatus.SessionStatusValid]: 'ADMIN_SESSION_STATUS_PAID',
  [SessionStatus.MiniSessionStatusValid]: 'ADMIN_SESSION_STATUS_PAID',
  [SessionStatus.SendErap]: 'ADMIN_SESSION_STATUS_SENT_TO_ERAP',
  [SessionStatus.Assigned]: 'ADMIN_SESSION_STATUS_IN_PROGRESS',
  [SessionStatus.Legal]: 'ADMIN_SESSION_STATUS_LEGAL',
  [SessionStatus.Confirm]: 'ADMIN_SESSION_STATUS_CONFIRMED',
  [SessionStatus.MiniSessionStatusFreePeriod]: 'ADMIN_SESSION_STATUS_LEGAL',
  [SessionStatus.MiniSessionStatusUncertain]: 'ADMIN_SESSION_STATUS_LEGAL',
  [SessionStatus.BenefitCodeMonthlyAbonement]: 'ADMIN_SESSION_STATUS_LEGAL',
};
